 <template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0604'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>{{ groupParamName + "_参数设备配置" }}</h4>
          <div>
            <el-button type="primary" class="adduser" @click="handleReturn">返回</el-button>
            <el-button type="primary" class="adduser" @click="handleAdd">添加</el-button>
          </div>
        </div>
        <!-- <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="handleRest"
              >重置</el-button
            >
          </el-form-item>
        </el-form> -->
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="设备名称">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="属性名称">
              <template slot-scope="scope">
                <p>{{ scope.row.attributeName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="排序号">
              <template slot-scope="scope">
                <p>{{ scope.row.orderNum }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备名称：" prop="eid">
                  <el-select v-model="ruleForm.eid" placeholder="请选择设备名称" clearable @change="deviceChange">
                    <el-option v-for="(item, index) in deviceArray" :label="item.name" :value="item.id" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="属性名称：" prop="attributeId">
                  <el-select v-model="ruleForm.attributeId" placeholder="请选择属性名称" clearable>
                    <el-option v-for="(item, index) in attributeArray" :label="item.name" :value="item.id" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="排序号：" prop="orderNum">
                  <el-input-number v-model="ruleForm.orderNum" placeholder="请输入排序号" :min="0" :max="9999" size="small" :precision="0" :step="1">
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        groupParamId: "",
      },
      total: 0, // 总数
      tableData: [],
      ruleForm: {
        // 添加、编辑弹窗表单
        id: "",
        groupParamId: "",
        type: "",
        eid: "",
        attributeId: "",
        orderNum: "",
      },
      rules: {
        // 添加、编辑弹窗表单规则
        eid: [
          {
            required: true,
            message: "请选择设备名称",
            trigger: "change",
          },
        ],
        attributeId: [
          {
            required: true,
            message: "请选择属性名称",
            trigger: "change",
          },
        ],
        orderNum: [
          {
            required: true,
            message: "请输入排序号",
            trigger: "blur",
          },
        ],
      },
      addEditTitle: "添加参数设备配置", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      deviceArray: [], // 设备数组
      attributeArray: [], // 属性数组
      groupParamName: "", // 大棚参数名称
    };
  },
  created() {
    this.ruleForm.type = this.$route.query.type;
    this.ruleForm.groupParamId = this.$route.query.groupParamId;
    this.searchForm.groupParamId = this.$route.query.groupParamId;
    this.groupParamName = this.$route.query.groupParamName;

    // 获取设备列表
    this.getDeviceList();

    // 查询
    this.getList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupParamId: "",
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.homeParam
        .getHomeGroupParamDeviceList(this.searchForm)
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
          }
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.homeParam.delHomeGroupParamDevice(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑参数设备配置";
      this.ruleForm.id = row.id;

      // 获取详情
      this.$api.homeParam
        .getHomeGroupParamDevice({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            this.ruleForm = res.data;

            // 获取属性列表
            this.getAttributeList();
          }
        });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加参数设备配置";
      this.ruleForm.id = "";
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.homeParam
            .saveHomeGroupParamDevice(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.handleCancel();
                this.handleSearch();
              }
            });
        }
      });
    },
    // 设备下拉切换
    deviceChange() {
      // 清空
      this.ruleForm.attributeId = "";
      this.attributeArray = [];

      // 获取属性列表
      this.getAttributeList();
    },
    // 获取设备列表
    getDeviceList() {
      if (this.ruleForm.type === "") {
        return;
      }

      if (this.ruleForm.type == 0) {
        // 数值设备
        this.$api.device
          .getNumericalsByGroupId({ groupId: this.$route.query.groupId })
          .then((res) => {
            if (res.code == 200) {
              res.data.forEach((val) => {
                this.deviceArray.push({
                  id: val.id,
                  name: val.name,
                });
              });
            }
          });
      } else if (this.ruleForm.type == 1) {
        // 视频设备
        this.$api.device
          .getVideosByGroupId({ id: this.$route.query.groupId })
          .then((res) => {
            if (res.code == 200) {
              res.data.forEach((val) => {
                this.deviceArray.push({
                  id: val.id,
                  name: val.name,
                });
              });
            }
          });
      }
    },
    // 获取属性列表
    getAttributeList() {
      if (this.ruleForm.type === "" || this.ruleForm.eid === "") {
        return;
      }

      this.$api.device
        .getDeviceAttributes({
          type: this.ruleForm.type,
          eid: this.ruleForm.eid,
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.attributeArray.push({
                id: val.id,
                name: val.cname,
              });
            });
          }
        });
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `homeParam`,
        query: {
          currentShow: "second",
          greenHouseId: this.$route.query.greenHouseId,
          oneGroupId: this.$route.query.oneGroupId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>